require('slick-carousel');
const $ = jQuery;

if($('.intro-carousel').length) {

    let introCarousel = $('.intro-carousel').slick({
        adaptiveHeight: true
    });


    function positionArrows(slide) {
        let imageHeight = $('.intro-carousel-slide-' + slide).find('img').outerHeight(),
            setHeight = imageHeight / 2;

        if($(window).width() < 992) {
            $('.intro-carousel').find('.slick-arrow').css('top', setHeight);
        } else {
            $('.intro-carousel').find('.slick-arrow').css('top', '');
        }
    }

    $(window).on('load', function () {
        positionArrows(0);
    });

    $(window).on('resize', function () {
        // positionArrows(0);
    });

    introCarousel.on('afterChange', function (slick, currentSlide) {
        if($(window).width() < 992) {
            positionArrows(currentSlide.currentSlide);
        }
    });

}
